export enum AuthPostAuthActionType {
    OpenProductMail = 'open_product_mail',
}
